import {
  type CheckboxOptionType,
  Radio,
  type RadioChangeEvent, type RadioGroupProps, Select, type SelectProps,
} from 'antd';
import { useCallback, useEffect } from 'react';

export interface DropdownInputProps extends SelectProps {
  onChange?: (value: string | string[]) => void;
  optionsLoading?: boolean;
  prefetchOptions?: boolean;
  handleFetchOptions?: Function;
  handleFocus?: Function;
  showRadioGroup?: boolean;
  radioGroupProps?: RadioGroupProps;
}

export default function DropdownInput({
  onChange,
  value,
  disabled,

  options,
  optionsLoading,
  prefetchOptions,
  handleFetchOptions,
  handleFocus,
  showRadioGroup,
  radioGroupProps,

  ...props
}: DropdownInputProps) {
  const handleClick = useCallback((newValue: string | string[] | undefined) => {
    if (onChange && newValue) {
      onChange(newValue);
    }
  }, [onChange]);
  const handleRadioChange = useCallback(
    (e: RadioChangeEvent) => {
      if (onChange) onChange(e.target.value);
    },
    [onChange],
  );

  const fetchOptions = useCallback(() => {
    if (!options?.length && handleFetchOptions) {
      handleFetchOptions();
    }
    if (handleFocus) handleFocus();
  }, [handleFetchOptions, handleFocus, options?.length]);

  useEffect(() => {
    // If prefetchOptions is true, fetch options on mount
    if (prefetchOptions) fetchOptions();
  }, [fetchOptions, prefetchOptions]);

  if (showRadioGroup && prefetchOptions) {
    return (
      <Radio.Group
        value={value}
        onChange={handleRadioChange}
        disabled={disabled}
        options={options?.length ? options as CheckboxOptionType[] : []}
        {...radioGroupProps}
      />
    );
  }
  return (
    <Select
      value={value}
      placeholder="Select a Value"
      optionFilterProp="label"
      options={options ?? []}
      loading={optionsLoading}
      onChange={handleClick}
      onFocus={fetchOptions}
      disabled={disabled}
      {...props}
    />
  );
}
